export const IMAGE_PRODUCT_FALLBACK_SRC = '/media/content/placeholder.png'
